import { render, staticRenderFns } from "./StatementsAcceptance.vue?vue&type=template&id=a6509b2c&scoped=true&"
import script from "./StatementsAcceptance.vue?vue&type=script&lang=js&"
export * from "./StatementsAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./StatementsAcceptance.vue?vue&type=style&index=0&id=a6509b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6509b2c",
  null
  
)

export default component.exports